export default "__VITE_ASSET__Bibbsi9F__"